import { Subscription } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UniCampaignsFacade } from '../../shared/uni-campaigns.facade';
import { AutoUnsubscribe } from '../../../../utils/auto-unsubscribe';
import { Country } from '../../../uni-countries/shared/uni-countries.model';

@Component({
  selector: 'cc-campaign-country-new-autocomplete',
  templateUrl: './campaign-country-new-autocomplete.component.html',
  styleUrls: ['./campaign-country-new-autocomplete.component.scss'],
})
export class CampaignCountryNewAutocompleteComponent extends AutoUnsubscribe implements OnInit {
  @Input() form: FormGroup;
  @Input() isActive = true;
  @Input() isEditable = true;

  chosenCountry: Country;
  countries: Country[];

  get contentForm(): FormGroup {
    return this.form.get('contentForm') as FormGroup;
  }

  get autocompleteControl(): FormControl {
    return this.contentForm.get('autocomplete') as FormControl;
  }

  constructor(private campaignFacade: UniCampaignsFacade) {
    super();
  }

  ngOnInit() {
    this.campaignFacade.setAutocompleteCountries();
    this.subs.add(this.setCountries());
  }

  setCountries(): Subscription {

    return this.campaignFacade.autocompleteCountries$.subscribe(countries => {
      if (!!countries) {
        const noneObject = {id: null, name: 'none', code: 'none', callingCode: '00'};
        countries = [noneObject, ...countries];
        const defaultCountry = countries.find(country => country.code === 'none');
        this.autocompleteControl.setValue(defaultCountry);
      }

      this.countries = countries;
    });
  }
}
